import React, { FC } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import { AssistMigrationPreview } from 'types/assist/assistMigration';

interface ConfirmRunDialogProps {
  open: boolean;
  businessName: string;
  storeCount: number;
  pendingActions: AssistMigrationPreview['actions'];
  onCancel: () => void;
  onConfirm: () => void;
}

export const ConfirmRunDialog: FC<ConfirmRunDialogProps> = ({
  open,
  businessName,
  storeCount,
  pendingActions,
  onCancel,
  onConfirm,
}) => (
  <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
    <DialogTitle>Run migration for {businessName}?</DialogTitle>
    <DialogContent dividers>
      <Typography variant="body2" sx={{ mb: 1 }}>
        This writes Assist 2.0 settings across {storeCount} location(s) using the values shown
        below. This cannot be undone from here.
      </Typography>
      {pendingActions.length > 0 ? (
        <ul style={{ margin: 0, paddingLeft: 18 }}>
          {pendingActions.map((action, index) => (
            <li key={`${action.type}-${index}`}>
              <Typography variant="body2" component="span" style={{ fontWeight: 600 }}>
                {action.title}
              </Typography>
              {action.detail ? (
                <Typography variant="caption" color="textSecondary" display="block">
                  {action.detail}
                </Typography>
              ) : null}
            </li>
          ))}
        </ul>
      ) : (
        <Typography variant="caption" color="textSecondary">
          All migration steps are already satisfied.
        </Typography>
      )}
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel}>Cancel</Button>
      <Button variant="contained" color="primary" onClick={onConfirm}>
        Confirm &amp; run
      </Button>
    </DialogActions>
  </Dialog>
);
